import { LenderName, PaymentMethodType } from '@nemuru-eng/js-api-client';

import { ALL_PAYMENT_METHODS } from '@/components/modules/PricingsList/_shared/schemas/pricingsForm.schema';
import { ALL_LENDERS } from '@/constants/AllLenders';

export const getAllowedLendersByPaymentMethodType = (
  paymentMethodType: PaymentMethodType | typeof ALL_PAYMENT_METHODS,
) => {
  const getLendersByPaymentMethod = (): LenderName[] => {
    switch (paymentMethodType) {
      case PaymentMethodType.AUTO_LOAN:
        return [
          LenderName.ABANCA,
          LenderName.ASTARA,
          LenderName.BBVA,
          LenderName.BS,
          LenderName.CAIXABANK,
          LenderName.CETELEM,
          LenderName.COFIDIS,
          LenderName.SANTANDER,
          LenderName.SANTANDER_CONSUMER,
          LenderName.SOYOU,
        ];
      case PaymentMethodType.CREDIT_LINE:
        return [LenderName.CAIXABANK, LenderName.FINONLINE];
      case PaymentMethodType.CONSUMER_LOAN_INSTALMENTS:
      case PaymentMethodType.CONSUMER_LOAN_SPLIT_PAY:
        return [
          LenderName.ABANCA,
          LenderName.BBVA,
          LenderName.BS,
          LenderName.CAIXABANK,
          LenderName.UPF,
          LenderName.SOYOU,
          LenderName.SANTANDER,
          LenderName.SANTANDER_CONSUMER,
          LenderName.CETELEM,
          LenderName.FINONLINE,
        ];
      case PaymentMethodType.BNPL_INSTALMENTS:
      case PaymentMethodType.BNPL_SPLIT_PAY:
        return [
          LenderName.APLAZAME,
          LenderName.ATRATO,
          LenderName.FLOA,
          LenderName.KUESKI,
          LenderName.PEPPER,
          LenderName.SEQURA_QUIX,
          LenderName.SEQURA,
          LenderName.KOIN,
        ];
      case PaymentMethodType.B2B_LOAN:
        return [LenderName.CAIXABANK];
      case ALL_PAYMENT_METHODS:
        return ALL_LENDERS.map((lender) => lender.name);
      default:
        return ALL_LENDERS.map((lender) => lender.name);
    }
  };

  return ALL_LENDERS.filter((lender) => getLendersByPaymentMethod().includes(lender.name));
};
